// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"1f2e08c1","74":"b69d8522","419":"863bae4b","466":"518af43f","527":"5d2ee0fb","561":"6d17599b","634":"1cb4bfe1","689":"2b01ff5e","787":"a1fbcab3","856":"22ab62ad","933":"af68eaab"}[chunkId] + ".chunk.js";
};